export default __webpack_public_path__ + "static/media/banner (2).7b6beb1b.jpg";